import React from 'react'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from '../../contexts/i18n/use'

export const QueueEmptyListItem = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { actions: {t}} = useTranslation();

  return (
    <ListItem className={classes.container} id="queues-emptylistitem-id"> 
      <ListItemText
        primary={<Typography component="span" variant="body1" className={classes.primarytext} id="queues-emptylistitem-text-id">{t('queuepage.noqueuesavailable')}</Typography>}>
      </ListItemText>
    </ListItem>
  ) 
}

const useStyles = makeStyles({
  container: theme => ({
    maxWidth: '500px',
    backgroundColor: theme.palette.listitem.main,
    paddingTop: 0,
    paddingBottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'
  }),
  primarytext: theme => ({
    color: theme.palette.secondary_text.main
  })
})